import axios from 'axios';
import { store } from './store';
import { setToken, setLogout } from './index';
import { API_URL, LICENSE_KEY } from './constants';


const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  paramsSerializer: { indexes: null },
});

const noAuthEndpoints = [
  '/auth/login',
  '/auth/register',
  '/auth/forgotpassword',
  '/auth/resetpassword',
  '/auth/refresh',
  '/auth/webauthn/authentication-options',
  '/auth/webauthn/authentication-verify',
  '/homepageconfig',
];

api.interceptors.request.use(
  (config) => {
    if (LICENSE_KEY) {
      config.headers['x-license-key'] = LICENSE_KEY;
    }
    const isNoAuth = noAuthEndpoints.some((path) => config.url?.includes(path));
    if (!isNoAuth) {
      const token = store.getState().token;
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const req = err.config;
    if (err.response?.status === 401 && !req._retry) {
      req._retry = true;
      try {
        const { data } = await axios.get(`${API_URL}/auth/refresh`, { withCredentials: true });
        store.dispatch(setToken(data.token));
        req.headers['Authorization'] = `Bearer ${data.token}`;
        req.headers['x-license-key'] = LICENSE_KEY;
        return api(req);
      } catch {
        store.dispatch(setLogout());
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
